<template>
  <div v-loading="dLoading" class="allDetail" element-loading-text="问题详情获取中...">
    <div v-show="isRead" class="read">
      <el-form ref="formData" :model="formData" size="small" label-width="80px" label-position="right">
        <el-form-item label="截  图:">
          <viewer :images="formData.md5List" class="MQcut">
            <img v-for="(img, index) in formData.cutList" :key="index" class="uploadpic"
              :src="questionImgListUrl(formData.prjId, img)" />
          </viewer>
        </el-form-item>
        <el-form-item label="文件名称:">
          {{ formData.fileName }}
        </el-form-item>
        <el-form-item label="问题状态:">
          <el-popover v-model="visible" placement="bottom" width="300" trigger="manual">
            <el-form ref="formstatus" :rules="statusRules" :model="formstatus" class="statusForm" size="small"
              label-position="top">
              <el-form-item label="问题状态:" prop="statusId">
                <el-select v-model="formstatus.statusId" size="small" placeholder="请选择">
                  <el-option v-for="item in dicData.dealList" :key="item.id" :label="item.cnName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="说明:">
                <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea" maxlength="200"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item class="footer">
                <el-button size="small" @click="visible = false">
                  取 消
                </el-button>
                <el-button size="small" type="primary" @click="changeStatus">
                  确 定
                </el-button>
              </el-form-item>
            </el-form>
            <span slot="reference" class="changeStatus" :class="{
              status1: formData.queStatus == '待修改',
              status2: formData.queStatus == '已修改',
              status3: formData.queStatus == '已取消',
              status4: formData.queStatus == '已复核',
            }" @click="dealStatus">{{ formData.queStatus }}</span>
          </el-popover>
        </el-form-item>
        <el-form-item label="严重等级:">
          {{ formData.problemType }}
        </el-form-item>
        <el-form-item label="问题描述:">
          <p class="contentMini"> {{ formData.checkContent }} </p>
        </el-form-item>
        <el-form-item label="审图要点:">
          <p class="contentMini"> {{ formData.drawingReviewPoints }} </p>
        </el-form-item>
        <el-form-item class="associatedFileStyle" label-width="0px">
          <span class="title">关联文件:</span>
          <ul style="margin-left: 5px">
            <li v-for="(item, index) in floderData" :key="index">
              <p class="fileNamestyle" :title="item.fileName" @click="preview(item)">
                {{ item.fileName }}
              </p>
              <p>
                <img :src="down" alt="下载" style="margin-right: 15px" @click="todown(item)" />
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="修 改 人:">
          <div>
            <span v-for="(item,index) in modifierNameList" :key="index" style="margin-right: 2px">
              <img :src="item.imgUrl" class="userAvator" alt="头像" style="margin-bottom: 2px" />
              <span>{{ item.modifierName }}</span>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="意见类型:">
          {{ formData.qmType }}
        </el-form-item>
        <el-form-item v-if="stageNameBoolean && !hideSubitem" label="阶 段:">
          {{ stageName }}
        </el-form-item>
        <el-form-item v-if="childNameBoolean && !hideSubitem" label="子 项:">
          {{ childName }}
        </el-form-item>
        <el-form-item v-if="specNameBoolean" label="专 业:">
          {{ specName }}
        </el-form-item>
        <el-form-item v-if="multiSpecNameBoolean" label="跨 专 业:">
          {{ multiSpecName }}
        </el-form-item>
        <el-form-item label="创建人:">
          <div style="display: flex;">
            <img :src="creatorAvator" class="userAvator" alt="头像" />
            <p>{{ formData.creatorName }}</p>
          </div>
        </el-form-item>
        <el-form-item label="创建时间:">
          {{ formData.createDate }}
        </el-form-item>
        <el-form-item label="问题来源:">
          {{ formData.source }}
        </el-form-item>
      </el-form>
    </div>
    <div v-show="!isRead" class="edit">
      <el-form ref="editform" :rules="rules" class="editform" :model="editform" size="small" label-width="80px"
        label-position="top">
        <el-form-item label="截  图:">
          <viewer :images="formData.md5List" class="MQcut">
            <img v-for="(img, index) in formData.cutList" :key="index" class="uploadpic"
              :src="questionImgListUrl(formData.prjId, img)" />
          </viewer>
        </el-form-item>
        <el-form-item label="文件名称:" class="changeBgc">
          <span class="content">{{ formData.fileName }}</span>
        </el-form-item>
        <el-form-item label="问题状态:" class="changeBgc">
          <span class="content">{{ formData.queStatus }}</span>
        </el-form-item>
        <el-form-item label="意见类型:" prop="qmTypeId">
          <el-radio-group v-model="editform.qmTypeId" size="small">
            <el-radio v-for="item in dicData.checkTypeList" :key="item.id" :label="item.id">
              {{ item.cnName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="严重等级:" prop="problemTypeId">
          <el-radio-group v-model="editform.problemTypeId" size="small">
            <el-radio v-for="item in dicData.severityLevelList" :key="item.id" :label="item.id">
              {{ item.cnName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问题描述:" prop="checkContent">
          <el-input v-model="editform.checkContent" type="textarea" rows="4" show-word-limit maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="审图要点:" class="itemStyle">
          <template #label>
            <div class="labelStyle">
              <span>审图要点:</span>
              <el-button class="rcStyle" type="primary" plain size="small" @click="showImgPoint">
                关联审图要点
              </el-button>
            </div>
          </template>
          <el-input v-model="editform.drawingReviewPoints" type="textarea" readonly></el-input>
        </el-form-item>
        <el-form-item label="关联文件:" class="associatedFileStyle">
          <template #label>
            <div class="labelStyle">
              <span>关联文件:</span>
              <el-button class="rcStyle" type="primary" plain size="small" @click="showAssociatedFile">
                关联文档目录树
              </el-button>
              <el-button class="rcStyle" type="primary" plain size="small" @click="uploadFiles">
                本地上传
              </el-button>
            </div>
          </template>
          <ul>
            <li v-for="(item, index) in floderData" :key="index">
              <p class="fileNamestyle" :title="item.fileName">
                {{ item.fileName }}
              </p>
              <p>
                <img :src="down" alt="下载" style="margin-right: 15px" @click="todown(item)" />
                <img :src="del" alt="删除" style="margin-right: 15px" @click="todel(index)" />
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="修改人:" prop="modifierIds">
          <el-select v-model="editform.modifierIds" size="small" filterable multiple collapse-tags placeholder="请选择">
            <el-option v-for="item in dicData.modifierList" :key="item.userId" :label="item.name" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>

        <template v-if="stageNameBoolean && !hideSubitem">
          <el-form-item v-if="stageName" label="阶 段:" class="changeBgc">
            <span class="content"> {{ stageName }}</span>
          </el-form-item>
          <el-form-item v-else label="阶 段:">
            <el-select v-model="editform.stageId" size="small" placeholder="请选择阶段">
              <el-option v-for="item in dicData.specStageChildVos.find(
                (ele) => ele.name == '阶段'
              ).optionalValues" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="childNameBoolean && !hideSubitem">
          <el-form-item v-if="childName" label="子 项:" class="changeBgc">
            <span class="content">{{ childName }}</span>
          </el-form-item>
          <el-form-item v-else label="子 项:">
            <el-select v-model="editform.stageChildId" :placeholder="`请选择${$titles.child}`">
              <el-option v-for="item in dicData.specStageChildVos.find(
                (ele) => ele.name == $titles.child
              ).optionalValues" :key="item.id" size="small" :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="specNameBoolean">
          <el-form-item v-if="specName" label="专 业:" class="changeBgc">
            <span class="content">{{ specName }}</span>
          </el-form-item>
          <el-form-item v-else size="small" label="专 业:">
            <el-select v-model="editform.specId" placeholder="请选择专业" @change="editform.multiSpecListspecIds = []">
              <el-option v-for="item in dicData.specStageChildVos.find(
                (ele) => ele.name == '专业'
              ).optionalValues" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="multiSpecNameBoolean">
          <el-form-item v-if="multiSpecName" label="跨 专 业:" class="changeBgc">
            <span class="content">{{ multiSpecName }}</span>
          </el-form-item>
          <el-form-item v-else label="跨 专 业:">
            <el-select v-model="editform.multiSpecListspecIds" size="small" placeholder="请选择跨专业" multiple collapse-tags>
              <el-option v-for="item in dicData.specStageChildVos
                .find((ele) => ele.name == '跨专业')
                .optionalValues.filter(
                  (ele) => ele.id != editform.specId && ele.cnName != specName
                )" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item label="创建人:" class="changeBgc">
          <span class="content">{{ formData.creatorName }}</span>
        </el-form-item>
        <el-form-item label="创建时间:" class="changeBgc">
          <span class="content">{{ formData.createDate }}</span>
        </el-form-item>
        <el-form-item label="问题来源:" class="changeBgc">
          <span class="content">{{ formData.source }}</span>
        </el-form-item>
        <el-form-item class="footer">
          <el-button size="small" @click="closeEdit">
            取 消
          </el-button>
          <el-button v-loading="addLoading" size="small" type="primary" @click="sureEdit">
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <check-img-point v-if="imgPoint" ref="checkImgPoint" />
    <associated-file v-if="associatedFileShow" ref="associatedFile" />
  </div>
</template>

<script>
const editParams = () => ({
  problemTypeId: "", // 严重等级
  checkContent: "", // 描述
  drawingReviewPoints: "", // 要点
  modifierIds: "", // 修改人
  qmTypeId: "", // 意见类型
  stageId: "", // 阶段
  specId: "", // 专业
  multiSpecListspecIds: [],
  stageChildId: ""
});
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
import requestIssueMg from "@/CommonDP/service/question-service";
import { downloadFile, questionImgUrlNew, questionImgUrl1 } from "@/CommonDP/utils";
import checkImgPoint from "@/CommonDP/components/checkImgPoint/index.vue";
import associatedFile from "@/CommonDP/components/associatedFile/index.vue";
import { mapState } from "vuex";
import { downloadUrltoken } from "@/CommonDP/utils";
import globalParams from "@/CommonDP/utils/globalParams";
import { gettouxAvatar } from '@/CommonDP/utils/index';
import { filePreviewV1 } from "@/CommonDP/utils/docPublic";
import navreplyVue from "./navreply.vue";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { uploader } from "@/CommonDP/utils/IUploader/dp";
export default {
  components: { checkImgPoint, associatedFile, historyProblem, navreplyVue, userItem },
  data() {
    return {
      hideSubitem: false,
      isRead: true,
      dLoading: false,
      addLoading: false,
      formData: {},
      dicData: {
        dealList: []
      },
      editform: editParams(),
      imgPoint: false,
      formstatus: {
        // 修改问题状态
        statusId: "", // 问题id
        content: ""
      },
      visible: false,
      currentUserID: "",
      statusRules: {
        statusId: [{ required: true, message: "问题状态不可为空", trigger: "change" }]
      },
      rules: {
        problemTypeId: [{ required: true, message: "严重等级不可为空", trigger: "change" }],
        checkContent: [{ required: true, message: "问题描述不可为空", trigger: "blur" }],
        qmTypeId: [{ required: true, message: "意见类型不可为空", trigger: "change" }],
        modifierIds: [{ required: true, message: "请选择修改人", trigger: "change" }]
      },
      stageName: "",
      stageNameBoolean: false,
      specName: "",
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: "",
      childNameBoolean: false,
      associatedFileShow: false,
      floderData: [],
      modifierNameList: [],
      down: require("@/CommonDP/assets/issueMgDown.png"),
      del: require("@/CommonDP/assets/issueMgDel.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      floderObj: (state) => state.uploaderAnnotation.floderObj,
      userInfo: (state) => state.user.userInfo
    }),
    editallParams() {
      const { problemTypeId, checkContent, drawingReviewPoints, modifierIds, qmTypeId, stageId, specId, multiSpecListspecIds, stageChildId } = this.editform;

      const multiSpecList = [];
      const muspecList = this.dicData.specStageChildVos.find((sor) => sor.name == "跨专业").optionalValues;
      if (multiSpecListspecIds.length && !this.dicData.specStageChildVos.find((ele) => ele.name == "跨专业").defaultValue) {
        multiSpecListspecIds.forEach((ele) => {
          const obj = {
            specId: ele,
            specName: muspecList.find((sor) => sor.id == ele)?.cnName
          };
          multiSpecList.push(obj);
        });
      }
      const annexFileList = [];
      if (!!this.floderData && this.floderData.length) {
        this.floderData.forEach((ele) => {
          const obj = {
            fileId: ele.fileId,
            fileName: ele.fileName,
            id: "",
            uploadType: ele.uploadType
          };
          annexFileList.push(obj);
        });
      }
      const modifierList = []; // 修改人多选
      if (modifierIds.length) {
        modifierIds.forEach((ele) => {
          const obj = {
            modifierId: ele,
            modifierName: this.dicData.modifierList.find((sor) => sor.userId == ele).name
          };
          modifierList.push(obj);
        });
      }
      let stageName = "";
      stageName =
          !this.dicData.specStageChildVos.some((ele) => ele.name == "阶段").defaultValue && stageId
            ? this.dicData.specStageChildVos.find((ele) => ele.name == "阶段").optionalValues.find((item) => item.id === stageId)?.cnName
            : "";

      let specName = "";
      specName =
          !this.dicData.specStageChildVos.some((ele) => ele.name == "专业").defaultValue && specId
            ? this.dicData.specStageChildVos.find((ele) => ele.name == "专业").optionalValues.find((item) => item.id === specId)?.cnName
            : "";

      let stageChildName = "";
      stageChildName =
          !this.dicData.specStageChildVos.some((ele) => ele.name == this.$titles.child).defaultValue && stageChildId
            ? this.dicData.specStageChildVos.find((ele) => ele.name == this.$titles.child).optionalValues.find((item) => item.id === stageChildId)?.cnName
            : "";

      const params = {
        checkContent,
        drawingReviewPoints,
        modifierList,
        problemTypeId,
        problemType: this.dicData.severityLevelList.find((ele) => ele.id == problemTypeId)?.cnName,
        qmTypeId,
        qmType: this.dicData.checkTypeList.find((ele) => ele.id == qmTypeId)?.cnName,
        questionId: this.formData.questionId,
        prjId: this.formData.prjId,
        autoScreenshotMd5: this.formData.autoScreenshotMd5,
        autoScreenshotFileId: this.formData.autoScreenshotFileId,
        autoScreenshotFileVersion: this.formData.autoScreenshotFileVersion,
        picMd5List: this.formData.picMd5List,
        screenshotFileList: this.formData.screenshotFileList,
        sectionPos: this.formData.sectionPos,
        coordinate: this.formData.coordinate,
        multiSpecList,
        stageId,
        stageName,
        specId,
        specName,
        stageChildId,
        stageChildName,
        annexFileList
      };
      return params;
    },
    statusParams() {
      const { statusId, content } = this.formstatus;
      const params = {
        content,
        prjId: this.formData.prjId,
        idList: [this.formData.questionId],
        statusId: this.formData.queStatusId,
        statusName: this.formData.queStatus,
        toStatusId: statusId,
        toStatusName: this.dicData.statusList.find((ele) => ele.id == statusId)?.cnName
      };
      return params;
    },
    creatorAvator() {
      return gettouxAvatar(this.formData.creatorId);
    }
  },
  watch: {
    // floderObj(newValue) {
    //   if (newValue.fileId) {
    //     this.floderData.push(newValue);
    //   } else {
    //     this.floderData = [];
    //   }
    //   console.log(this.floderData, "this.floderData");
    // }
  },
  created() {
    this.hideSubitem = globalParams.get("project.issue.subitem");
  },
  methods: {
    dealStatus() {
      const { creatorId, queStatus, modifierList } = this.formData;
      this.visible = true;
      this.currentUserID = this.userInfo.userId;
      if (creatorId == this.currentUserID && modifierList.some((ele) => ele.modifierId == this.currentUserID)) {
        // 同一个人
        if (queStatus == "待修改") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已修改" || ele.cnName == "已取消");
        } else if (queStatus == "已修改") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已复核" || ele.cnName == "待修改" || ele.cnName == "已取消");
        } else if (queStatus == "已复核") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
        } else if (queStatus == "已取消") {
          this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改");
        }
      } else {
        // 创建人
        if (creatorId == this.currentUserID) {
          if (queStatus == "待修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已取消");
          } else if (queStatus == "已修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已复核" || ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已复核") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已取消") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改");
          }
        } else if (modifierList.some((ele) => ele.modifierId == this.currentUserID)) {
          // 处理人
          if (queStatus == "待修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已修改" || ele.cnName == "已取消");
          } else if (queStatus == "已修改") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已复核") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "已取消");
          } else if (queStatus == "已取消") {
            this.dicData.dealList = this.dicData.statusList.filter((ele) => ele.cnName == "待修改");
          }
        } else {
          this.visible = false;
          this.$message.warning("很抱歉,仅问题创建人或者问题处理人有修改问题状态的权限");
        }
      }
    },
    async changeStatus() {
      this.$refs.formstatus.validate(async (valid) => {
        if (valid) {
          try {
            const res = await requestIssueMg.drawingannotationupdateStatus(this.statusParams);
            if (res.result == "0") {
              this.$message.success("修改成功");
              this.visible = false;
              this.$emit("update");
              this.getDetail(this.formData.questionId);
              this.isRead = true;
            }
          } catch (error) {
            this.visible = false;
          }
        }
      });
    },
    async getDetailInit(questionId, prjId, fileId) {
      this.isRead = true;
      await this.getDic(prjId, fileId, questionId);
    },
    async getDic(prjId, fileId, questionId) {
      const id = fileId.includes(",") ? "" : fileId;
      const res = await requestIssueMg.queryDict2(prjId, id);
      // if(res.result =='0'){
      this.dicData = res.data;
      await this.getDetail(questionId);
      // }
    },
    async getDetail(questionId) {
      this.visible = false;
      this.formData = {};
      this.dLoading = true;
      try {
        const res = await requestIssueMg.getDrawingQuestionDetails(questionId);
        this.$emit("openshowDetail");
        this.formData = res.data;
        this.floderData = [];
        if (!!res.data.annexFileList && res.data.annexFileList.length) {
          this.floderData = res.data.annexFileList;
        }
        this.formData.cutList = [];
        if (this.formData.screenshotFileList?.length) {
          this.formData.cutList = [...this.formData.screenshotFileList];
        } else if (this.formData.picMd5List?.length) {
          this.formData.picMd5List.forEach(item => {
            const pic = { fileMd5: item };
            this.formData.cutList.push(pic);
          });
        }
        if (this.formData.autoScreenshotMd5) {
          const { autoScreenshotMd5, autoScreenshotFileId, autoScreenshotFileVersion } = this.formData;
          const autoScreenshot = { fileMd5: autoScreenshotMd5, fileId: autoScreenshotFileId, fileVersion: autoScreenshotFileVersion };
          this.formData.cutList.unshift(autoScreenshot);
        }
        this.formData.md5List = this.formData.cutList.map(item => item.fileMd5);
        this.editform.problemTypeId = this.formData.problemTypeId; // 严重等级
        this.editform.checkContent = this.formData.checkContent;
        this.editform.drawingReviewPoints = this.formData.drawingReviewPoints;
        const ids = [];
        this.formData.modifierList.forEach((ele) => {
          ids.push(ele.modifierId);
        });
        this.editform.modifierIds = ids;

        this.modifierNameList = [];
        this.formData.modifierList.forEach((element) => {
          this.$set(element, 'imgUrl', gettouxAvatar(element.modifierId));
        });
        this.modifierNameList = this.formData.modifierList;

        this.editform.qmTypeId = this.formData.qmTypeId;
        if (this.formData.specStageChildVos.some((ele) => ele.name == "阶段")) {
          this.stageName = this.formData.specStageChildVos.find((ele) => ele.name == "阶段").value;
          this.stageNameBoolean = true;
        } else {
          this.stageName = "";
          this.stageNameBoolean = false;
        }

        if (this.formData.specStageChildVos.some((ele) => ele.name == "专业")) {
          this.specName = this.formData.specStageChildVos.find((ele) => ele.name == "专业").value;
          this.specNameBoolean = true;
        } else {
          this.specName = "";
          this.specNameBoolean = false;
        }

        if (this.formData.specStageChildVos.some((ele) => ele.name == "跨专业")) {
          this.multiSpecName = this.formData.specStageChildVos.find((ele) => ele.name == "跨专业").value || "";
          this.multiSpecNameBoolean = true;
        } else {
          this.multiSpecName = "";
          this.multiSpecNameBoolean = false;
        }

        if (this.formData.specStageChildVos.some((ele) => ele.name == this.$titles.child)) {
          this.childName = this.formData.specStageChildVos.find((ele) => ele.name == this.$titles.child).value;
          this.childNameBoolean = true;
        } else {
          this.childName = "";
          this.childNameBoolean = false;
        }

        this.dLoading = false;
      } catch (error) {
        this.dLoading = false;
      }
    },
    // 编辑
    openEdit() {
      if (this.dicData.specStageChildVos.some((ele) => ele.name == "阶段")) {
        this.stageName = "";

        this.stageNameBoolean = true;
      } else {
        this.stageName = "";
        this.stageNameBoolean = false;
      }
      if (this.dicData.specStageChildVos.some((ele) => ele.name == "专业")) {
        this.specName = "";

        this.specNameBoolean = true;
      } else {
        this.specName = "";
        this.specNameBoolean = false;
      }
      if (this.dicData.specStageChildVos.some((ele) => ele.name == "跨专业")) {
        this.multiSpecName = "";
        this.multiSpecNameBoolean = true;
      } else {
        this.multiSpecName = "";
        this.multiSpecNameBoolean = false;
      }
      if (this.dicData.specStageChildVos.some((ele) => ele.name == this.$titles.child)) {
        this.childName = "";

        this.childNameBoolean = true;
      } else {
        this.childName = "";
        this.childNameBoolean = false;
      }
      // 有阶段
      if (this.stageNameBoolean && !this.stageName) {
        const name = this.formData.specStageChildVos.find((ele) => ele.name == "阶段").value;
        const list = this.dicData.specStageChildVos.find((ele) => ele.name == "阶段").optionalValues;
        this.editform.stageId = name ? list.find((ele) => ele.cnName == name).id : "";
      }
      // 有专业
      if (this.specNameBoolean && !this.specName) {
        const name = this.formData.specStageChildVos.find((ele) => ele.name == "专业").value;
        const list = this.dicData.specStageChildVos.find((ele) => ele.name == "专业").optionalValues;
        this.editform.specId = name ? list.find((ele) => ele.cnName == name).id : "";
      }
      // 跨专业
      if (this.multiSpecNameBoolean && !this.multiSpecName) {
        const nameArray = this.formData.specStageChildVos.find((ele) => ele.name == "跨专业").value.split(",");
        const list = this.dicData.specStageChildVos.find((ele) => ele.name == "跨专业").optionalValues;
        const ids = [];
        nameArray.forEach((name) => {
          if (name) {
            const id = list.find((ele) => ele.cnName == name).id;
            ids.push(id);
          }
        });
        this.editform.multiSpecListspecIds = ids;
      }
      // 有子项
      if (this.childNameBoolean && !this.childName) {
        const name = this.formData.specStageChildVos.find((ele) => ele.name == this.$titles.child).value;
        const list = this.dicData.specStageChildVos.find((ele) => ele.name == this.$titles.child).optionalValues;
        this.editform.stageChildId = name ? list.find((ele) => ele.cnName == name).id : "";
      }

      this.isRead = false;
    },
    // 确定编辑
    async sureEdit() {
      this.$refs.editform.validate(async (valid) => {
        if (valid) {
          this.addLoading = true;
          try {
            const res = await requestIssueMg.DrawingQuestionEdit(this.editallParams);
            if (res.result == "0") {
              this.$message.success("编辑成功");
              this.addLoading = false;
              this.$emit("refresh");
              this.getDetail(this.formData.questionId);
              this.isRead = true;
            }
          } catch (error) {
            this.addLoading = false;
          }
        } else {
          this.$message.info("必填项不可为空");
        }
      });
    },
    // 取消编辑
    closeEdit() {
      this.editform = editParams();
      this.getDetail(this.formData.questionId);
      this.isRead = true;
    },
    questionImgListUrl(prjId, img) {
      const { fileMd5, fileId, fileVersion } = img || {};
      if (!fileMd5) return;
      if (fileId) return questionImgUrlNew(fileMd5, fileId, fileVersion);
      return questionImgUrl1(fileMd5);
    },
    showImgPoint() {
      this.imgPoint = true;
      this.$nextTick(() => {
        this.$refs.checkImgPoint.showDialog();
        this.$refs.checkImgPoint.getAlldata();
      });
    },
    //  获取点击的审图要点数据
    getPointInfo(val) {
      this.editform.drawingReviewPoints = val.mainPoint || "";
      this.imgPoint = false;
    },
    showAssociatedFile() {
      this.associatedFileShow = true;
      this.$nextTick(() => {
        this.$refs.associatedFile.showDialog();
      });
    },
    // 关联文档数据
    getAssociatedFile(val) {
      this.associatedFileShow = false;
      const arr1 = val;
      const arr2 = this.floderData;
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [...arr1, ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))];
      const isnotfloderData = [...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))];
      this.floderData = isfloderData;
      for (const key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(`文件${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        }, 10);
      }
    },
    // 本地上传
    async uploadFiles() {
      const params = {
        prjId: this.formData.prjId,
        folderId: "",
        versionId: ""
      };
      await uploader.getHiddenParams(params);
      const list = await uploader.open({ params, showPanel: true, once: false });
      list.forEach(this.fileAdded);
    },
    fileAdded(val) {
      if (val && val.fileId) {
        val.uploadType = 2;
        this.floderData.push(val);
      } else {
        this.floderData = [];
      }
    },
    todown(row) {
      console.log(row, "row");
      const prjId = this.formData.prjId;
      const fileId = row.fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      downloadFile(fileUrl);
    },
    todel(index) {
      const obj = {};
      this.floderData = this.floderData.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []); // 设置cur默认类型为数组，并且初始值为空的数组
      this.floderData.splice(index, 1);
    },
    preview(row) {
      const data = {
        fileId: row.fileId,
        versionId: row.fileVersion || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      filePreviewV1(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.allDetail {
  width: 100%;
  height: 100%;
  padding: 15px 15px 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  .read{
    /deep/ .el-form-item {
      margin-bottom:0px
    }
  }
  .edit {
    /deep/.el-select {
      width: 100%;
    }
  }
  .MQcut {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic {
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
    }
  }
  .itemStyle {
    width: 100%;
    .el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    .el-form-item__content {
      margin-top: 30px;
    }
  }
  .contentMini {
    padding: 5px 0 0 0;
    user-select: none;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    min-height: 20px;
    word-wrap: break-word;
  }
  .associatedFileStyle {
    width: 100%;
    .el-form-item__label {
      width: 100% !important;
      display: flex;
    }
    .el-form-item__content {
      margin-top: 30px;

    }
    .title{
      font-size: 14px;
      line-height: 30px;
      height: 30px;
      color: #606266;
      padding: 0 12px 0 0;
      user-select: none;
      margin-left: 10px;
    }
    li {
      display: flex;
      justify-content: space-between;
      color: var(--theme-color);
      cursor: pointer;
      .fileNamestyle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 330px;
        padding-left: 5px;
      }
    }
    li:hover {
      background: #eef1ff;
    }
  }
  .userAvator {
    border-radius: 50%;
    width: 32px;
    height: 30px;
    margin-top: 0px;
    display: inline-block;
    vertical-align: top;
    margin-right: 2px;
  }
  .labelStyle {
    font-size: 14px;
    line-height: 28px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    > span {
      font-size: 14px;
      line-height: 28px;
      margin-right: 10px;
    }
  }
  .changeBgc {
    >>> .el-form-item__content {
      box-sizing: border-box;
      padding-left: 15px;
      background: rgba(179, 201, 253, 0.122);
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .changeStatus {
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 50px;
  }
  .status1 {
    background: #fce9df;
    color: #eb5757;
  }
  .status2 {
    background: #ffffdf;
    color: #eac100;
  }
  .status3 {
    background: #f2f2f2;
    color: #8b8888;
  }
  .status4 {
    background: #def6e4;
    color: #00b632;
  }
  .statusForm {
    padding: 5px 15px;
    box-sizing: border-box;
  }
}
.allDetail::-webkit-scrollbar {
  width: 6px;
}
.allDetail::-webkit-scrollbar-thumb {
  border-radius: 3px;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  background-color: #e8e8e8;
}
.allDetail::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  border-radius: 3px;
}
.content {
  padding: 5px 0 5px 5px;
  user-select: none;
  width: 100%;
  font-size: 14px;
  line-height: 30px;
  max-height: 85px;
  min-height: 40px;
  color: var(--key-color);
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  background: rgba(179, 201, 253, 0.12);
}
</style>
